export default "/images/67f9a820ace820692eb122f9734e4e50.avif";